
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import SearchBar from './SearchBar';
import {
  Grid, Box, Typography, TextField, IconButton, Button,
  Dialog, DialogTitle, DialogContent, DialogActions, Paper
} from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { Circles } from 'react-loader-spinner'; // Import the spinner
import { Visibility, VisibilityOff } from '@mui/icons-material';
import Fade from '@mui/material/Fade';
import Avatar from '@mui/material/Avatar';
import PersonIcon from '@mui/icons-material/Person';
// -3 points APpointment Not Completed
// mine const token = 'bbd8d93a722d4c64a381ee27824abfa9'; // Replace with your actual tokennn
//const token = '9f48bda3674e4fe888a2c2c491c8523d';
function Home({pinGood, setPinGood}) {
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [newTotal, setNewTotal] = useState(0)
  const [paperBucks, setPaperBucks] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showQuickBucks, setShowQuickBucks] = useState(false);
  const [fadeIn, setFadeIn] = useState(false);
  const [clearQueryTrigger, setClearQueryTrigger] = useState(0);
  const [logEntries, setLogEntries] = useState([]);
  const [pin, setPin] = useState("");
  const [paperBucksVisible, setPaperBucksVisible] = useState(false);

  const updateCustomerAlphaBucks = async (newBucks, amntAdded, type) => {
    setLoading(true); // Set loading to true

    const customerUpdate = {
      id: selectedCustomer.id,
      name: selectedCustomer.name,
      total_points: Number(newBucks),
    };

    console.log("NEW TOTAL " + newBucks);

    try {
      // POST request to update the customer
      const token = localStorage.getItem('authToken');
      const updateResponse = await axios.post(`${process.env.REACT_APP_API_HOST}/api/v1.0/customers`, customerUpdate, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('Update Response:', updateResponse.data);

      // GET request to verify the update
      const getResponse = await axios.get(`${process.env.REACT_APP_API_HOST}/api/v1.0/customers/${selectedCustomer.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });

      console.log('Get Response:', getResponse.data);
      if (Number(getResponse.data.total_points) == Number(newBucks)) {
        selectedCustomer.total_points = Number(newBucks);
        setError(null);
        setOpenDialog(true);

        const payload = {
          CustomerFullName: selectedCustomer.name,
          LoyverseID: selectedCustomer.id,
          AlphaBucksAdded: amntAdded,
          AlphaBucksBalance: newBucks,
          TransactionType: type,
        };

        sendLog(payload);
      }
      else {
        setError("Error: " + selectedCustomer.name + "'s points were not updated.");
      }
    } catch (err) {
      console.error('Error:', err);
      console.log("RESPONSE STATUS " + err.response.status);
      if (err.response.status === 401 || err.response.status === 403) {
        // Token is expired or invalid
        setPinGood(false);
      }
      setError(err.message);
    } finally {
      setLoading(false); // Set loading to false
    }
  };

  const sendLog = async (payload) => {
    try {
      const token = localStorage.getItem('authToken');

      const response = await axios.post(`${process.env.REACT_APP_API_HOST}/log`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });

      console.log(response.data.message);
    } catch (error) {
      console.error("Error sending log:", error);
      if (error.response) {
        console.log(error.response.data.error || "Failed to send log.");
        console.log("RESPONSE STATUS " + error.response.status);
        if (error.response.status === 401 || error.response.status === 403) {
          // Token is expired or invalid
          setPinGood(false);
        }
      } else {
        console.log("Failed to send log. Please try again.");
      }
    }
  };

  const fetchLog = async (id) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}/log/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });

      setLogEntries(response.data);
    } catch (error) {
      console.error("Error fetching log:", error);
      setLogEntries([]);
      if (error.response) {
        console.log(error.response.data.error || "Failed to fetch log.");
        console.log("RESPONSE STATUS " + error.response.status);
        if (error.response.status === 401 || error.response.status === 403) {
          // Token is expired or invalid
          setPinGood(false);
        }
      } else {
        console.log("Failed to fetch log. Please try again.");
      }
    }
  };

  const handleToggleDetails = () => {
    if (!showDetails) {
      fetchLog(selectedCustomer.id);
    }
    setShowDetails(!showDetails);

  };

  const handleToggleQuickBucks = () => {
    setShowQuickBucks(!showQuickBucks);
  };

  const handleCustomerSelect = (customer) => {
    if (customer == null) {
      setSelectedCustomer(null);
      return;
    }
    setNewTotal(customer.total_points);
    setSelectedCustomer(customer);
    fetchLog(customer.id);
  };

  const handleTotalChange = (event) => {
    setNewTotal(event.target.value);
  }

  const handlePaperBucksChange = (event) => {
    setPaperBucks(event.target.value);
  }

  const handleQuickBucksClick = (alphaBucks, type) => {
    console.log(`You have earned ${alphaBucks} Alpha Bucks`);
    const newBucks = Number(selectedCustomer.total_points + alphaBucks);
    setNewTotal(newBucks);
    updateCustomerAlphaBucks(newBucks, alphaBucks, type);
    setPaperBucks(0); // Clear the paper bucks to zero once submitted.
    setPaperBucksVisible(false);
  };

  const handleApplyBucksClick = (event) => {
    updateCustomerAlphaBucks(newTotal, newTotal, "Direct Balance Change");
  }

  const handleCloseDialog = () => {
    setOpenDialog(false);
    //setShowDetails(false);
    //setSelectedCustomer(null);
    //setClearQueryTrigger((prev) => prev + 1);
  };

  const handleApplyPin = async () => {
    setSelectedCustomer(null);
    
    const res = await fetch(`${process.env.REACT_APP_API_HOST}/ablogin`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pin }),
    });

    const data = await res.json();

    if (res.ok) {
      localStorage.setItem('authToken', data.authToken);
      console.log('Logged in!');
      setPinGood(true);
    } else {
      console.log(data.message);
      setPinGood(false);
    }
  }

  const handlePinChange = (event) => {
    setPin(event.target.value)
  }

  const keysToDisplay = ["email", "phone_number", "address", "city", "region", "postal_code", "total_spent", "total_visits", "id"];

  const keyMapping = {
    name: "Customer Name",
    email: "Email",
    phone_number: "Phone Number",
    address: "Address",
    city: "City",
    region: "Region",
    postal_code: "Postal Code",
    total_spent: "Total Spent",
    total_visits: "Total Visits",
    total_points: "current Alpha Bucks balance",
    id: "Loyverse Internal ID"
    // Add other mappings as needed
  };

  return (
    <div>
      <Box sx={{ marginTop: 10 }} />

      <Typography sx={{ marginTop: 2, marginBottom: 2 }} variant="h5" fontWeight="bold" >
        Alpha Bucks Updater
      </Typography>

      {pinGood == false &&
        <Grid container sx={{ marginTop: 0 }} spacing={2} alignItems="center">
          <Grid item>
            <Box sx={{ marginLeft: 0, whiteSpace: 'nowrap' }}>
              <TextField
                variant="outlined"
                label="Enter PIN"
                value={pin}
                onChange={handlePinChange}
                fullWidth
                InputProps={{
                  sx: {
                    '& input': {
                      textAlign: 'center', // Centered text
                      fontSize: '2rem',    // Entered text font size (2x placeholder size)
                    },
                  },
                }}

                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '10px',  // Rounded corners
                    height: '56px',        // Fixed height
                    width: '120px',
                    '& input': {
                      textAlign: 'center', // Centered text
                      fontSize: '2rem',    // Entered text font size (2x placeholder size)
                      padding: 0,          // Adjust padding if necessary
                    },
                  },
                  '& .MuiInputBase-input::placeholder': {
                    fontSize: '1rem', // Placeholder font size
                  },
                }}
              />
            </Box>
          </Grid>
          <Grid item xs>
            <Box sx={{ padding: 1 }}>
              <Button disabled={loading}
                variant="contained"
                color="primary"
                onClick={handleApplyPin}
                sx={{
                  whiteSpace: 'nowrap',
                  height: '60px',
                  textTransform: 'none', // Optional: to keep the text case as is
                }}
              >
                Login
              </Button>
            </Box>
          </Grid>
        </Grid>
      }

      {pinGood &&
        <SearchBar setPinGood={setPinGood} clearQueryTrigger={clearQueryTrigger} onCustomerSelect={handleCustomerSelect} />
      }

      {pinGood && selectedCustomer && (

        <div>
          <Typography sx={{ marginTop: 2 }} variant="h5" fontWeight="bold" >
            Selected Customer:
          </Typography>

          <Paper sx={{ padding: 2, marginLeft: 0 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h4" component="h1" >

                {selectedCustomer.name}
              </Typography>
              <Button
                variant="contained"
                startIcon={showDetails ? <VisibilityOff /> : <Visibility />}
                onClick={handleToggleDetails}
              >
                {showDetails ? 'Hide Details' : 'Show Details'}
              </Button>
            </Box>

            {/* Display Logs */}
            {showDetails && logEntries.length > 0 && (
              <div
                style={{
                  marginTop: "20px",
                  maxHeight: "300px",
                  overflowY: "auto", // Keeps the scroll functionality
                  border: "1px solid #ccc",
                  padding: "10px",
                }}
              >
                <table style={{ width: "100%", borderCollapse: "collapse" }} aria-label="Transaction Logs">
                  <caption style={{ textAlign: "left", fontWeight: "bold", marginBottom: "10px" }}>
                    Transaction Logs
                  </caption>
                  <thead>
                    <tr>
                      <th style={{ textAlign: "left", borderBottom: "1px solid #ccc", padding: "5px" }}>Alpha Bucks Added</th>
                      <th style={{ textAlign: "left", borderBottom: "1px solid #ccc", padding: "5px" }}>Alpha Bucks Balance</th>
                      <th style={{ textAlign: "left", borderBottom: "1px solid #ccc", padding: "5px" }}>Transaction Type</th>
                      <th style={{ textAlign: "left", borderBottom: "1px solid #ccc", padding: "5px" }}>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {logEntries.map((entry, index) => {
                      const date = new Date(entry.Date); // Parse the date
                      const formattedDate = `${String(date.getMonth() + 1).padStart(2, "0")}/${String(date.getDate()).padStart(2, "0")}/${String(date.getFullYear()).slice(-2)}`;
                      const formattedTime = new Intl.DateTimeFormat("en-US", {
                        hour: "numeric",
                        minute: "numeric",
                        second: "numeric",
                        hour12: true,
                        timeZoneName: "short",
                      }).format(date); // Format time with timezone abbreviation
                      return (
                        <tr key={index}>
                          <td style={{ textAlign: "left", borderBottom: "1px solid #ccc", padding: "5px" }}>{entry.AlphaBucksAdded}</td>
                          <td style={{ textAlign: "left", borderBottom: "1px solid #ccc", padding: "5px" }}>{entry.AlphaBucksBalance}</td>
                          <td style={{ textAlign: "left", borderBottom: "1px solid #ccc", padding: "5px" }}>{entry.TransactionType}</td>
                          <td style={{ textAlign: "left", borderBottom: "1px solid #ccc", padding: "5px" }}>{formattedDate} {formattedTime}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
            {showDetails && (
              <Grid sx={{ marginLeft: 2, marginTop: 2 }} container>
                <Grid item xs={4}>
                  <Box>
                    {keysToDisplay.map((key) => (
                      <Typography key={key} variant="body1" fontWeight="bold">
                        {keyMapping[key] || key}:
                      </Typography>
                    ))}
                  </Box>
                </Grid>
                <Grid item xs={8}>
                  <Box>
                    {keysToDisplay.map((key) => (
                      <Typography key={key} variant="body1">
                        {selectedCustomer[key] !== null ? selectedCustomer[key].toString() : 'N/A'}
                      </Typography>
                    ))}
                  </Box>
                </Grid>
              </Grid>
            )}

            <Box sx={{ marginTop: 1 }} />

            <Box sx={{ borderRadius: '10px', padding: 1, backgroundColor: '#e3eeff' }}>
              <Box sx={{ marginLeft: 0, marginBottom: 0, maxWidth: 600 }} >
                <Typography variant="body1" >
                  <Typography sx={{ fontStyle: 'italic', textDecoration: 'underline' }} component="span" fontWeight="bold">
                    Current
                  </Typography> Alpha Bucks balance:
                </Typography>

                <Typography sx={{ marginLeft: 2 }} variant="body1" fontSize={40}>
                  {selectedCustomer["total_points"]} Alpha Bucks
                </Typography>
              </Box>

              <Box sx={{ flexGrow: 1, padding: 0, marginTop: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={6}>
                    <Button disabled={loading} variant="contained" fullWidth sx={{ whiteSpace: 'nowrap' }}
                      onClick={() => handleQuickBucksClick(6, "Mentoring/Coaching")}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        +6 Alpha Bucks:
                      </Typography>
                      <Typography component="span" sx={{ marginLeft: 1 }}>
                        Mentoring/Coaching
                      </Typography>
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <Button disabled={loading} variant="contained" fullWidth sx={{ whiteSpace: 'nowrap' }}
                      onClick={() => handleQuickBucksClick(5, "Baby Bag")}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        +5 Alpha Bucks:
                      </Typography>
                      <Typography component="span" sx={{ marginLeft: 1 }}>
                        Baby Bag
                      </Typography>
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <Button disabled={loading} variant="contained" fullWidth sx={{ whiteSpace: 'nowrap' }}
                      onClick={() => handleQuickBucksClick(3, "1/2 Mentoring or Coaching Visiting")}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        +3 Alpha Bucks:
                      </Typography>
                      <Typography component="span" sx={{ marginLeft: 1 }}>
                        1/2 Mentoring or Coaching Visit
                      </Typography>
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <Button disabled={loading} variant="contained" fullWidth sx={{ whiteSpace: 'nowrap' }}
                      onClick={() => handleQuickBucksClick(2, "Class Or Group")}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }} >
                        +2 Alpha Bucks:
                      </Typography>
                      <Typography component="span" sx={{ marginLeft: 1 }}>
                        Class or Group
                      </Typography>
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <Button disabled={loading} variant="contained" fullWidth sx={{ whiteSpace: 'nowrap' }}
                      onClick={() => handleQuickBucksClick(1, "JFL")}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        +1 Alpha Buck:
                      </Typography>
                      <Typography component="span" sx={{ marginLeft: 1 }}>
                        JFL
                      </Typography>
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <Button disabled={loading} variant="contained" fullWidth sx={{ whiteSpace: 'nowrap' }}
                      onClick={() => handleQuickBucksClick(1, "Reading Log/Homework/Survey")}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        +1 Alpha Buck:
                      </Typography>
                      <Typography component="span" sx={{ marginLeft: 1 }}>
                        Reading Log/Homework/Survey
                      </Typography>
                    </Button>
                  </Grid>
                </Grid>
              </Box>

              <Box
                sx={{
                  display: 'flex', // Enable flexbox
                  justifyContent: 'center', // Center horizontally
                  alignItems: 'center', // Center vertically
                  padding: 2,
                  width: '100%', // Optional: Make the Box take full width of the container
                }}
              >

                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  justifyContent="center"
                  sx={{
                    textAlign: 'center', // Optional: To center-align child content
                  }}
                >

                  {/* TextField */}
                  {paperBucksVisible &&
                    <>
                      <Grid item>
                        <TextField
                          variant="outlined"
                          label="Paper Bucks Received?"
                          value={paperBucks}
                          onChange={handlePaperBucksChange}
                          InputProps={{
                            sx: {
                              '& input': {
                                textAlign: 'center', // Center text inside input
                                fontSize: '2rem', // Large font size
                              },
                            },
                          }}
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '10px', // Rounded corners
                              height: '56px', // Fixed height
                              width: '200px', // Adjust width
                              '& input': {
                                textAlign: 'center',
                                fontSize: '2rem',
                                padding: 0, // Remove extra padding if needed
                              },
                            },
                            '& .MuiInputBase-input::placeholder': {
                              fontSize: '1rem', // Placeholder font size
                            },
                          }}
                        />
                      </Grid>

                      {/* Button */}
                      <Grid item>
                        <Button
                          disabled={loading}
                          variant="contained"
                          onClick={() => handleQuickBucksClick(Number(paperBucks), "Paper Bucks Redemption")}
                          sx={{
                            //backgroundColor: '#814C95',
                            whiteSpace: 'nowrap',
                            height: '40px',
                            textTransform: 'none', // Keep text case as is
                            fontWeight: 700,
                            fontSize: 16,
                          }}
                        >
                          Submit Received Paper Bucks
                          {loading && (
                            <div
                              className="spinner-container"
                              style={{ marginLeft: '10px' }}
                            >
                              <Circles
                                height={40}
                                width={40}
                                color="#00BFFF"
                                visible={true}
                                ariaLabel="oval-loading"
                                secondaryColor="#00BFFF"
                                strokeWidth={2}
                                strokeWidthSecondary={2}
                              />
                            </div>
                          )}
                        </Button>
                      </Grid>
                    </>
                  }
                  <Grid item>
                    <Button disabled={loading} variant="contained" fullWidth sx={{ whiteSpace: 'nowrap', backgroundColor: paperBucksVisible ? 'red' : undefined, }}
                      onClick={() => setPaperBucksVisible(!paperBucksVisible)}>
                      {paperBucksVisible &&
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Cancel
                        </Typography>
                      }
                      {!paperBucksVisible &&
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Add Paper Bucks
                        </Typography>
                      }
                    </Button>
                  </Grid>
                </Grid>
              </Box>


            </Box>
          </Paper>

          <Paper sx={{ padding: 2, marginTop: 1 }}>
            <Box sx={{ marginTop: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h5" fontWeight="bold" >
              </Typography>
              <Button
                variant="contained"
                startIcon={showQuickBucks ? <VisibilityOff /> : <Visibility />}
                onClick={handleToggleQuickBucks}
              >
                {showQuickBucks ? 'Hide Advanced' : 'Show Advanced'}
              </Button>
            </Box>

            {showQuickBucks &&
              <div>
                <Box sx={{ marginLeft: 0, maxWidth: 600 }} display="flex" alignItems="center">
                  <Typography variant="body1" >
                    <Typography sx={{ fontStyle: 'italic', textDecoration: 'underline' }} component="span" fontWeight="bold">
                      New
                    </Typography> Alpha Bucks balance:
                  </Typography>
                </Box>

                <Box sx={{ marginLeft: 0, maxWidth: 600 }}>
                  <Grid container sx={{ marginTop: 0 }} spacing={2} alignItems="center">
                    <Grid item>
                      <Box sx={{ marginLeft: 2, whiteSpace: 'nowrap' }}>
                        <TextField
                          variant="outlined"
                          label="Enter New Total"
                          value={newTotal}
                          onChange={handleTotalChange}
                          fullWidth
                          InputProps={{
                            sx: {
                              '& input': {
                                textAlign: 'center', // Centered text
                                fontSize: '2rem',    // Entered text font size (2x placeholder size)
                              },
                            },
                          }}

                          sx={{
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '10px',  // Rounded corners
                              height: '56px',        // Fixed height
                              width: '120px',
                              '& input': {
                                textAlign: 'center', // Centered text
                                fontSize: '2rem',    // Entered text font size (2x placeholder size)
                                padding: 0,          // Adjust padding if necessary
                              },
                            },
                            '& .MuiInputBase-input::placeholder': {
                              fontSize: '1rem', // Placeholder font size
                            },
                          }}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs>
                      <Box sx={{ padding: 1 }}>
                        <Button disabled={loading}
                          variant="contained"
                          color="primary"
                          onClick={handleApplyBucksClick}
                          sx={{
                            whiteSpace: 'nowrap',
                            height: '60px',
                            textTransform: 'none', // Optional: to keep the text case as is
                          }}
                        >
                          Apply New Balance
                          {loading && (
                            <div className="spinner-container" style={{ marginLeft: '10px' }}>
                              <Circles
                                height={40}
                                width={40}
                                color="#00BFFF"
                                visible={true}
                                ariaLabel="oval-loading"
                                secondaryColor="#00BFFF"
                                strokeWidth={2}
                                strokeWidthSecondary={2}
                              />
                            </div>
                          )}
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                  {error && <p>Error: {error}</p>}
                </Box>

              </div>
            }
          </Paper>

          <Dialog open={openDialog} onClose={handleCloseDialog}>
            <DialogTitle sx={{ textAlign: 'center' }}>Alpha Bucks Updated!</DialogTitle>
            <DialogContent sx={{ textAlign: 'center' }}>
              <Typography>
                <Typography component="span" fontWeight="bold">
                  {selectedCustomer.name}
                </Typography>
                's new Alpha Bucks total is
              </Typography>
              <Typography fontSize={100}>{selectedCustomer.total_points}!</Typography>
            </DialogContent>
            <DialogActions >
              <Button onClick={handleCloseDialog} color="primary">
                OK
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}

    </div>
  );
}

export default Home;
